const YouTube = () => {
  return (
    <svg viewBox="0 0 32 32">
      <path d="M16.576 24.9764L11.2418 24.8788C9.51473 24.8448 7.78334 24.9127 6.09011 24.5602C3.51432 24.0336 3.33184 21.4513 3.14089 19.2853C2.87779 16.2402 2.97965 13.1398 3.47615 10.1201C3.75645 8.42577 4.85952 7.41473 6.56538 7.30471C12.3239 6.90543 18.1208 6.95275 23.8665 7.13903C24.4734 7.1561 25.0844 7.24944 25.6827 7.35568C28.6364 7.87384 28.7084 10.8001 28.8999 13.2634C29.0908 15.7522 29.0102 18.2537 28.6452 20.7255C28.3524 22.7721 27.7922 24.4884 25.4281 24.654C22.466 24.8707 19.5719 25.0451 16.6014 24.9896C16.6015 24.9764 16.5845 24.9764 16.576 24.9764ZM13.44 19.795C15.6722 18.5123 17.8618 17.251 20.0813 15.9769C17.8449 14.6942 15.6595 13.4329 13.44 12.1588V19.795Z" />
    </svg>
  )
}

export default YouTube
